/* eslint-disable no-extend-native */
import Utility from "./Utility";

// String only extension
export {};
declare global {
    interface String {
        fromBase64(): Uint8Array;
        fromBase64String(): string;
        toBase64(): String;
        asBlob(contentType: string): Blob;
        toBlob(contentType: string): Blob;
        fromDataUrl(): string;
        toDataUrl(type?: string): string;
        download(name: string, type?: string): void;
        fromHtml(): string;
        encodeHtml(): string;
        truncate(length: number): string;
        isDate(): boolean;
        toDate(): Date;
        toTime(): Date;
        addCss(addition: string): string;
        remCss(removal: string): string;
        toggleCss(value: string, force?: boolean): string;
        extractCurrencySymbol(): string;
        extractNumber(): Number;
        stripReactName(): string;
    }
}

if (!String.prototype.fromBase64) {
    String.prototype.fromBase64 = function fromBase64(
        this: string,
    ): Uint8Array {
        return Uint8Array.from(atob(this), c => c.charCodeAt(0));
    };
}

if (!String.prototype.fromBase64String) {
    String.prototype.fromBase64String = function fromBase64String(
        this: string,
    ): string {
        return atob(this);
    };
}

if (!String.prototype.toBase64) {
    String.prototype.toBase64 = function fromBase64(this: string): String {
        return btoa(unescape(encodeURIComponent(this)));
    };
}

if (!String.prototype.asBlob) {
    String.prototype.asBlob = function asBlob(
        this: string,
        contentType: string,
    ): Blob {
        const byteCharacters = this;
        const byteNumbers = new Uint8Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        return new Blob([byteNumbers], { type: contentType });
    };
}

if (!String.prototype.toBlob) {
    String.prototype.toBlob = function toBlob(
        this: string,
        contentType: string,
    ): Blob {
        const byteArrays = [];
        const byteCharacters = atob(Utility.stripDataUrl(this.toString()));
        for (var offset = 0; offset < byteCharacters.length; offset += 512) {
            var slice = byteCharacters.slice(offset, offset + 512);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    };
}

if (!String.prototype.toDataUrl) {
    String.prototype.toDataUrl = function toDataUrl(
        this: string,
        type: string | null = null,
    ): string {
        if (!type) {
            switch (this.fromBase64().byteArrayType()) {
                case "png":
                    type = "png";
                    break;
                case "svg":
                    type = "svg+xml";
                    break;
                case "jpg":
                    type = "jpg";
                    break;
                case "gif":
                    type = "gif";
                    break;
            }
            type = `image/${type}`;
        }

        return `data:${type};base64,${this}`;
    };
}

if (!String.prototype.download) {
    String.prototype.download = function download(
        this: string,
        name: string,
        type: string | null = null,
    ): void {
        let link = document.createElement("a");
        link.href = this.toDataUrl(type);
        link.download = name;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    };
}

if (!String.prototype.fromDataUrl) {
    String.prototype.fromDataUrl = function fromDataUrl(this: string): string {
        const marker = ";base64,";

        return this.substring(
            this.indexOf(marker) >= 0
                ? this.indexOf(marker) + marker.length
                : 0,
        );
    };
}

if (!String.prototype.fromHtml) {
    String.prototype.fromHtml = function fromHtml(this: string): string {
        let temp = this.replace(/(<meta([^]+?)\/>)/gi, "")
                .replace(/(<title([^]+?)<\/title>)/gi, "")
                .replace(/(<script([^]+?)<\/script>)/gi, "")
                .replace(/(<style([^]+?)<\/style>)/gi, "")
                .replace(/(\\x3C!([^>]+)>)/gi, "")
                .replace(/(<([^>]+)>)/gi, "")
                .replace(/&nbsp;/g, " ")
                .replace(/\t/g, " ")
                .replace(/\n/g, " ")
                .replace(/\r/g, " ")
                .trim(),
            temp2 = "";

        do {
            temp2 = temp;
            temp = temp.replace(/ {2}/g, " ");
        } while (temp2.length !== temp.length);

        return temp;
    };
}

if (!String.prototype.encodeHtml) {
    String.prototype.encodeHtml = function encodeHtml(this: string): string {
        return this.replace(
            /[\u00A0-\u9999<>&]/g,
            i => "&#" + i.charCodeAt(0) + ";",
        );
    };
}

if (!String.prototype.truncate) {
    String.prototype.truncate = function truncate(
        this: string,
        length: number,
    ): string {
        return this.length > length ? this.substring(0, length) : this;
    };
}

if (!String.prototype.isDate) {
    String.prototype.isDate = function isDate(this: string): boolean {
        return Utility.stringIsDate(this);
    };
}

if (!String.prototype.toDate) {
    String.prototype.toDate = function toDate(this: string): Date {
        return Utility.stringToDate(this);
    };
}

if (!String.prototype.toTime) {
    String.prototype.toTime = function toTime(this: string): Date {
        return Utility.stringToTime(this);
    };
}

if (!String.prototype.addCss) {
    String.prototype.addCss = function addCssImp(
        this: string,
        addition: string,
    ): string {
        return Utility.addCss(this, addition);
    };
}

if (!String.prototype.remCss) {
    String.prototype.remCss = function remCssImp(
        this: string,
        removal: string,
    ): string {
        return Utility.remCss(this, removal);
    };
}

if (!String.prototype.toggleCss) {
    String.prototype.toggleCss = function toggleCssImp(
        this: string,
        value: string,
        force?: boolean,
    ): string {
        return Utility.toggleCss(this, value, force);
    };
}

if (!String.prototype.extractCurrencySymbol) {
    String.prototype.extractCurrencySymbol = function extractCurrencySymbol(
        this: string,
    ): string {
        if (this.length > 0 && isNaN(parseInt(this[0]))) return this[0];

        return "";
    };
}

if (!String.prototype.extractNumber) {
    String.prototype.extractNumber = function extractNumber(
        this: string,
    ): Number {
        let temp = "";
        for (let index = 0; index < this.length; index++) {
            let value = Number(this[index]);
            if (!isNaN(value)) temp += value;
            if (this[index] === ".") temp += ".";
        }
        return temp.length > 0 ? Number(temp) : 0;
    };
}

if (!String.prototype.stripReactName) {
    String.prototype.stripReactName = function stripReactName(
        this: string,
    ): string {
        const segs = this.split("/").last().split(".");
        return segs.length > 1
            ? `${segs[0]}.${segs[segs.length - 1]}`
            : segs[0];
    };
}
